import React from "react";
import { motion } from "motion/react";
const ProductCategory = ({ category }) => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 2,
        duration: 1,
        ease: "easeOut"
      }
    })
    
  };
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.4,
        duration: 1,
        ease: "easeOut"
      }
    })
  };

  return (
    <div>
      <h1>{category.title}</h1>
      {category.items.map((item, index) => (
        <div key={index} className="content-container">
          <motion.h2 className="heading-margin"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    variants={textVariants}>{item.name}</motion.h2>
          <motion.table initial="hidden"
          variants={cardVariants}
          whileInView="visible"
          viewport={{ once: false }} src={item.image} alt={item.name}>
            <thead>
              <tr>
                {item.scientificName && <th>Scientific Name</th>}
                {item.localName && <th>Local Name</th>}
                {item.hindiName && <th>Hindi Name</th>}
                {item.englishName && <th>English Name</th>}
                {item.family && <th>Family</th>}
                {item.centerOfOrigin && <th>Center of Origin</th>}
                {item.commonName && <th>Common Name</th>}
                {item.plantParts && <th>Plant parts used</th>}
                {item.chromosomeNumber && <th>Chromosome Number</th>}
              </tr>
            </thead>
            <tbody>
              <tr>
                {item.scientificName && <td>{item.scientificName}</td>}
                {item.localName && <td>{item.localName}</td>}
                {item.hindiName && <td>{item.hindiName}</td>}
                {item.englishName && <td>{item.englishName}</td>}
                {item.family && <td>{item.family}</td>}
                {item.centerOfOrigin && <td>{item.centerOfOrigin}</td>}
                {item.commonName && <td>{item.commonName}</td>}
                {item.plantParts && <td>{item.plantParts}</td>}
                {item.chromosomeNumber && <td>{item.chromosomeNumber}</td>}
              </tr>
            </tbody>
          </motion.table>
          <motion.img initial="hidden"
          variants={cardVariants}
          whileInView="visible"
          viewport={{ once: false }} src={item.image} alt={item.name} />
          <motion.p initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    variants={textVariants}>{item.description}</motion.p>
        </div>
      ))}
    </div>
  );
};

export default ProductCategory;